module.exports = __webpack_public_path__ + "static/img/e12.9740c9d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/iot/e12.png
// module id = NGJw
// module chunks = 0